import { getMetrics } from '../../common/api//MetricsAPIHelper';
import { getMetricsForPortco } from '../../common/api/PortcoMetricsAPIHelper';

export const getCombinedMetricsData = async (portcoId, metricCode = null) => {
    console.log("MetricsHistoryHelper :: getCombinedMetricsData :: Starting");
    try {
        const metrics = await getMetrics();
        const portcoMetrics = await getMetricsForPortco(portcoId);
        console.log(metrics);
        console.log(portcoMetrics);

        if(!portcoMetrics) {
            console.warn('Warning: PortcoMetrics returned null');
            return [];
        }

        // filter out metrics that are hidden unless metricCode is provided
        const visiblePortcoMetrics = portcoMetrics.filter(portcoMetric => {
            const matchingMetric = metrics.find(metric => metric.metric_id === portcoMetric.metric_id);
            return matchingMetric && (metricCode || !matchingMetric.hidden_metric);  
        });

        const combinedMetricsData = visiblePortcoMetrics.map(portcoMetric => {
            const matchingMetric = metrics.find(metric => metric.metric_id === portcoMetric.metric_id);

            if(matchingMetric) {
                return {
                    ...matchingMetric,
                    portco_metric_id: portcoMetric.portco_metric_id,
                    metric_date: portcoMetric.metric_date,
                    metric_value: portcoMetric.metric_value,
                    metric_reported_by_user_id: portcoMetric.metric_reported_by_user_id,
                    metric_reported_by_email: portcoMetric.metric_reported_by_email
                }
            }
        });

        // If metricCode is provided, filter the combinedMetricsData to include only those records.
        const filteredMetricsData = metricCode 
            ? combinedMetricsData.filter(metric => metric.metric_code === metricCode) 
            : combinedMetricsData;

        console.log("MetricsHistoryHelper :: getCombinedMetricsData :: combinedMetricsData :: ", filteredMetricsData);
        return filteredMetricsData;
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
}


